// Components
import {CommonModule} from '@angular/common';
import {HttpClientModule} from '@angular/common/http';
import {NgModule} from '@angular/core';
import {FlexLayoutModule} from '@angular/flex-layout';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {RouterModule} from '@angular/router';
import {ActionIconComponent} from '@app/shared/components/action/action-icon/action-icon.component';
import {ToolbarComponent} from '@app/shared/components/action/toolbar/toolbar.component';
import {CardTitleToolbarComponent} from '@app/shared/components/card/card-title-toolbar/card-title-toolbar.component';
import {CardTitleComponent} from '@app/shared/components/card/card-title/card-title.component';
import {ConfirmDialogComponent} from '@app/shared/components/dialog/confirm-dialog/confirm-dialog.component';
import {SimpleDialogComponent} from '@app/shared/components/dialog/simple-dialog/simple-dialog.component';
import {ErrorComponent} from '@app/shared/components/error/error.component';
import {FormActionsComponent} from '@app/shared/components/form/form-actions/form-actions.component';
import {ValdemortDefaultComponent} from '@app/shared/components/valdemort-default/valdemort-default.component';
import {FocusDirective} from '@app/shared/directives/focus.directive';
import {SelectDirective} from '@app/shared/directives/select.directive';
import {PropercasePipe} from '@app/shared/pipes/propercase.pipe';
import {FontAwesomeModule} from '@fortawesome/angular-fontawesome';
import {NgProgressModule} from '@ngx-progressbar/core';
import {NgProgressHttpModule} from '@ngx-progressbar/http';
import {NgProgressRouterModule} from '@ngx-progressbar/router';
import {TranslateModule} from '@ngx-translate/core';
import {MomentModule} from 'ngx-moment';
import {OrderModule} from 'ngx-order-pipe';
import {NgxSecurityModule} from 'ngx-security';
import {ValdemortModule} from 'ngx-valdemort';
import * as PrimeNG from 'primeng/primeng';
import {OverlayPanelModule} from 'primeng/primeng';
import {TableModule} from 'primeng/table';
import {DividerComponent} from './components/divider/divider.component';
import {CalendarComponent} from '@app/shared/components/calendar/calendar.component';
import {LoadingComponent} from '@app/shared/components/loading/loading.component';
import {DynamicDialogModule} from 'primeng/components/dynamicdialog/dynamicdialog';
import {EditorComponent} from '@app/shared/components/editor/editor.component';
import {FullCalendarModule} from 'primeng/fullcalendar';
import {ColorboxComponent} from '@app/shared/components/colorbox/colorbox.component';
import {DisableControlDirective} from '@app/shared/directives/disable-control.directive';
import {TabValidDirective} from '@app/shared/directives/tab-valid.directive';
import {HtmlPopUpComponent} from '@app/shared/components/html-pop-up/html-pop-up.component';
import {PageHeaderComponent} from '@app/shared/components/page-header.component';
import {FordocUserPipe} from '@app/shared/pipes/fordoc-user.pipe';
import {ConfirmationComponent} from '@app/shared/components/confirmation/confirmation.component';
import {YesNoComponent} from '@app/shared/components/YesNo/yes-no.component';
import {YesNoValidationComponent} from '@app/shared/components/YesNo/yes-no-validation.component';
import {RolesPipe} from './pipes/roles.pipe';

const MODULES: any[] = [
  CommonModule,
  FormsModule,
  ReactiveFormsModule,
  HttpClientModule,
  RouterModule,
  TranslateModule,

  FontAwesomeModule, // Font awesome
  FlexLayoutModule, // Angular Flex Layout

  MomentModule, // ngx-moment
  NgxSecurityModule, // ngx-security
  OrderModule, // ngx-order-pipe
  ValdemortModule, // ngx‑valdemort

  // ngx-progressbar
  NgProgressModule,
  NgProgressHttpModule,
  NgProgressRouterModule,


  PrimeNG.SharedModule,
  PrimeNG.ProgressSpinnerModule,
  PrimeNG.ScrollPanelModule,
  PrimeNG.InputTextModule,
  PrimeNG.PasswordModule,
  PrimeNG.InputTextareaModule,
  PrimeNG.TooltipModule,
  PrimeNG.PanelModule,
  PrimeNG.InputSwitchModule,
  PrimeNG.DropdownModule,
  PrimeNG.ButtonModule,
  PrimeNG.MenuModule,
  PrimeNG.DialogModule,
  PrimeNG.ConfirmDialogModule,
  PrimeNG.BlockUIModule,
  PrimeNG.RadioButtonModule,
  PrimeNG.CalendarModule,
  PrimeNG.MultiSelectModule,
  PrimeNG.TabViewModule,
  PrimeNG.TreeModule,
  PrimeNG.CheckboxModule,
  PrimeNG.ChartModule,
  PrimeNG.InputTextareaModule,
  PrimeNG.AutoCompleteModule,
  PrimeNG.FieldsetModule,
  PrimeNG.InputMaskModule,
  PrimeNG.FileUploadModule,
  PrimeNG.EditorModule,
  PrimeNG.TriStateCheckboxModule,
  PrimeNG.ContextMenuModule,
  PrimeNG.ListboxModule,
  PrimeNG.CardModule,
  OverlayPanelModule,
  FullCalendarModule,
  TableModule,
  DynamicDialogModule,
];

const DECLARATIONS: any[] = [
  // Pipes
  PropercasePipe,
  FordocUserPipe,

  // Directives
  FocusDirective,
  SelectDirective,
  DisableControlDirective,
  TabValidDirective,

  // Components
  CardTitleComponent,
  CardTitleToolbarComponent,
  ToolbarComponent,
  FormActionsComponent,
  SimpleDialogComponent,
  ConfirmDialogComponent,
  ErrorComponent,
  ActionIconComponent,
  DividerComponent,
  CalendarComponent,
  ValdemortDefaultComponent,
  LoadingComponent,
  EditorComponent,
  ColorboxComponent,
  HtmlPopUpComponent,
  PageHeaderComponent,
  ConfirmationComponent,
  YesNoComponent,
  YesNoValidationComponent,
   RolesPipe
];


@NgModule({
  imports: MODULES,
  declarations: DECLARATIONS,
  exports: [...MODULES, ...DECLARATIONS],
  entryComponents: [HtmlPopUpComponent, ConfirmationComponent]
})
export class SharedModule { }
